import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import withAuth from '../../../components/Services/WithAuth';
import './style.css';
import { sectionTemplateMapDetails } from './helper';
import { getSectionTemplateDetails, setSectionTemplateExternalId } from './action';
import { setFinancialSurveyDownloadLink } from '../../../Analyst/Cases/View/action';
import fileSaver from 'file-saver';
class ViewSectionTemplateComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            downloadButton: null,
            sectionTemplate: {
                sectionType: '',
                displayName: '',
                sectionDataTableType: '',
            },
            viewFlag: true
        }
    }
    componentDidMount() {
        const sectionTemplateId = this.props.match.params.sectionTemplateId;
        if (sectionTemplateId) {
            this.props.getSectionTemplateDetails(sectionTemplateId);
            this.setState({
                downloadButton: <div className="btn-group pull-right" role="group" aria-label="Section Template Download">
                    <button type="button" className="btn btn-light" title="Go Back" onClick={(event) => this.handleCancel(event)}>
                        <span className="fa fa-edit" aria-hidden="true"></span>
                    </button>
                </div>
            })
        }
    }
    componentDidUpdate(prevProps) {
        const { sectionTemplateFetchDetails, sectionTemplateFileUrl, downloadUrl } = this.props
        if (sectionTemplateFetchDetails !== prevProps.sectionTemplateFetchDetails) {

            this.setState({
                sectionTemplate: sectionTemplateMapDetails(sectionTemplateFetchDetails.data)
            })
        }

        if (sectionTemplateFileUrl !== prevProps.sectionTemplateFileUrl) {
            window.open(sectionTemplateFileUrl);
        }
        if (downloadUrl !== prevProps.downloadUrl) {
            var blob = new Blob([downloadUrl], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fileSaver.saveAs(blob, `${this.state.sectionTemplate.displayName}.xlsx`);
        }
    }
    handleModifySectionTemplate = (event) => {
        const { id } = this.props.sectionTemplateFetchDetails.data;
        this.props.history.push(`/sectiontemplate/edit/${id}`);
    }
    handleDownloadSectionTemplate = (event) => {
        event.preventDefault();
        if (this.state.sectionTemplate.sectionType === 'FINANCIAL') {
            this.props.setFinancialSurveyDownloadLink(this.props.sectionTemplateFetchDetails.data.externalId)
        } else {
            this.props.setSectionTemplateId(this.props.sectionTemplateFetchDetails.data.externalId);
        }
    }
    handleCancel = () => {
        this.props.history.push('../search');
    }
    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">
                        Section Template
                    </h4>
                    <div className="view-sectiontemplate">
                        {/* Menu Buttons */}
                        <div className="btn-group" role="group" aria-label="Scorecard Actions">
                            <button type="button" className="btn btn-light" title="Edit Section Template" onClick={this.handleModifySectionTemplate}>
                                <span className="icon-edit" aria-hidden="true"></span>
                            </button>
                            <button type="button" className="btn btn-light" title="Download Section Template" onClick={this.handleDownloadSectionTemplate}>
                                <span className="icon-download" aria-hidden="true"></span>
                            </button>
                            <button type="button" className="btn btn-light" title="Delete Section Template" onClick={this.handleDelete}>
                                <span className="icon-delete" aria-hidden="true"></span>
                            </button>
                        </div>
                    </div>
                </div>

                {/*<div className="btn-group pull-left mr-3" role="group" aria-label="Section Template Cancel">*/}
                {/*<button type="button" className="btn btn-light" title="Go Back" onClick={this.handleCancel}>*/}
                {/*<span className="fa fa-arrow-left fa-fw" aria-hidden="true"></span>*/}
                {/*</button>*/}
                {/*</div>*/}
                <Card className="mb-4">
                    <CardHeader className="header-blue">
                        <Row>
                            <Col>Template Name</Col>
                            <Col>Display Name for Report</Col>
                            <Col>Section Type</Col>
                            <Col>Keys Type</Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col>{this.state.sectionTemplate.displayName}</Col>
                            <Col>{this.state.sectionTemplate.reportDisplayName}</Col>
                            <Col>{this.state.sectionTemplate.sectionType}</Col>
                            <Col>{this.state.sectionTemplate.sectionDataTableType}</Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    sectionTemplateFetchDetails: state.sectionTemplateDetails.sectionTemplateDetails,
    sectionTemplateFileUrl: state.sectionTemplateDetails.sectionTemplateDownloadUrl,
    downloadUrl: state.section.downloadUrl
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    getSectionTemplateDetails: (data) => { dispatch(getSectionTemplateDetails(data)) },
    setSectionTemplateId: (id) => { dispatch(setSectionTemplateExternalId(id)) },
    setFinancialSurveyDownloadLink: (id) => { dispatch(setFinancialSurveyDownloadLink(id)) }
})
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(ViewSectionTemplateComponent));
